import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const BriefIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 14 14"
  >
    <path d="M11.333.667c.368 0 .667.298.667.666v2.505h-1.333V2H1.333v10.667h9.334v-1.84H12v2.506a.667.667 0 0 1-.667.667H.667A.667.667 0 0 1 0 13.333v-12C0 .965.298.667.667.667zM6.667 7.333v1.333H3.333V7.333zm2-2.666V6H3.333V4.667z" />
    <path d="M8.762 7.216c1.48-.288 2.148-.962 2.434-2.454.025-.127.205-.127.23 0 .285 1.492.954 2.166 2.434 2.454.126.025.126.207 0 .232-1.48.288-2.149.964-2.434 2.456-.025.128-.205.128-.23 0-.286-1.492-.955-2.166-2.434-2.456-.127-.025-.127-.207 0-.232" />
  </svg>
);
BriefIcon.displayName = 'BriefIcon';
export default BriefIcon;
